<template>
  <div style="position: relative">
    <loading-overlay :loading="loading" />
    <app-timeline v-if="events.length > 0">
      <app-timeline-item
        v-for="(logItem, index) in events.filter((el) => el.operation)"
        :key="index"
        :title="logItem.operation"
        :subtitle="logItem.creator ? logItem.creator.full_name : ''"
        :time="getTime(logItem.created_at)"
        :variant="getColor(logItem)"
      />
    </app-timeline>
    <div class="text-center my-2" v-else style="opacity: 0.6">
      لا يوجد أنشطة حتى الآن
    </div>
  </div>
</template>

<script>
import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";
import LoadingOverlay from "../LoadingOverlay.vue";

export default {
  components: {
    AppTimeline,
    AppTimelineItem,
    LoadingOverlay,
  },
  props: {
    loading: {
      type: Boolean,
      default: () => null,
    },
    events: {
      // type: Array,
      default: () => [],
    },
  },
  data: () => {
    return {
      colors: ["warning", "success", "success", "info", "danger"],
    };
  },
  methods: {
    getColor(item) {
      return item.operation &&
        (item.operation.includes("updated") || item.operation.includes("تعديل"))
        ? "info"
        : item.operation &&
          (item.operation.includes("created") ||
            item.operation.includes("إنشاء") ||
            item.operation.includes("إضافة"))
        ? "success"
        : item.operation &&
          (item.operation.includes("deleted") || item.operation.includes("حذف"))
        ? "danger"
        : "secondary";
    },
    getTime(time) {
      return this.$moment(time).locale("ar-iq").fromNow();
    },
  },
};
</script>
